import { CDN_URL } from '../../constants/constants.js'

const PREVIEW_URL_REGEX = /https:\/\/api.(.*?)interacty.me\/api\/projects\/(.*?)\/content/

export const convertPreviewUrlToRemixHTMLUrl = previewUrl => {
    const [, host, hash] = PREVIEW_URL_REGEX.exec(previewUrl)
    return `https://p.${host}interacty.me/${hash}/index.html`
}

export const convertTemplateUrlToRemixHTMLUrl = templateUrl => {
    const [hash] = /[^/]*$/.exec(templateUrl)
    return `${CDN_URL}/${hash}/index.html`
}
